/**
 * Chrome del panel del terapeuta: marco con contenido scrolleable + bottom tab bar
 * persistente (móvil primero). Vive DENTRO del "device" de 480px (a diferencia de
 * AdminLayout, que es a ancho completo). Cada pantalla hija renderiza su propio
 * ScreenHeader (título + back contextual) dentro del área scrolleable; el tab bar
 * queda fijo al fondo, garantizando salida desde cualquier pantalla.
 */
import { Outlet } from "react-router-dom";
import { RequireRole } from "../../auth/guards.js";
import { TabBar } from "../../components/TabBar.js";
import s from "./TherapistLayout.module.css";

export function TherapistLayout() {
  return (
    <RequireRole permitidos={["terapeuta"]}>
      <div className={s.layout}>
        <main className={s.scroll}>
          <Outlet />
        </main>
        <TabBar />
      </div>
    </RequireRole>
  );
}
